"use strict";

exports.__esModule = true;
exports.default = void 0;

// https://caniuse.com/es6-module
function supportsStaticImport() {
  var script = document.createElement('script');
  return 'noModule' in script;
}

var _default = supportsStaticImport;
exports.default = _default;